import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { CustomContainer } from "components/atoms/DependencyHelper";
import VASMessage from "components/molecules/VASMessage/VASMessage";

import { imagePrefix } from 'utils/helperServices';

import styles from './AddOns.module.scss'

const VasContainer = dynamic(
  import("components/organisms/VASContainer/VASContainer"),
  { ssr: false }
);

const AddOns = (props) => {
  const selectedDealDetails = useSelector(state => state.dealDetails.selectedDealDetails);
  const isVAS = useSelector(state => state.common.features?.vas)

  return (
    <>
      {isVAS && (
        <CustomContainer className={`${styles["vasContainer"]}`}>
          <VasContainer
            dealData={selectedDealDetails}
            isVasLoadedCallback={props.isVasAvailableWithCurrentDeal}
            vasRemoved={props.isVasRemoved}
          />
        </CustomContainer>
      )}

      {props.isShowVas && (
        <>
          <CustomContainer className={`${styles["banner"]}`}>
            <img
              className={styles["banner__icon"]}
              src={`${imagePrefix}/assets/images/Error.svg`}
            />
            <span>
              {
                "We’ve added Contract Cover by default because we believe in its value for you. You can remove it, but before you do, please read why we think you should keep it..."
              }
            </span>
          </CustomContainer>
          <CustomContainer>
            <VASMessage
              messageTitle={props.contractCoverTitle}
              messageDescription={props.contractCoverDescription}
            />
          </CustomContainer>
        </>
      )}
    </>
  );
}

AddOns.propTypes = {
  contractCoverTitle: PropTypes.string,
  contractCoverDescription: PropTypes.string,
  isShowHeader: PropTypes.bool,
  isShowVas: PropTypes.bool,
  isVasAvailableWithCurrentDeal: PropTypes.func,
  isVasRemoved: PropTypes.object,
};

AddOns.defaultProps = {
  isShowHeader: true,
};

export default AddOns;
